import { render, staticRenderFns } from "./PaymentsFinisheds.vue?vue&type=template&id=2c6c20b8&scoped=true&lang=pug&"
import script from "./PaymentsFinisheds.vue?vue&type=script&lang=js&"
export * from "./PaymentsFinisheds.vue?vue&type=script&lang=js&"
import style0 from "./PaymentsFinisheds.vue?vue&type=style&index=0&id=2c6c20b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c6c20b8",
  null
  
)

export default component.exports